/**
 * Auth flow helpers. Presentation copy lives in src/locales/{locale}/auth.json (i18n namespace "auth").
 */

export type AuthFlow = 'signIn' | 'signUp' | 'forgotPassword' | 'confirmSignUp' | 'confirmResetPassword';

export function getAuthFlow(route: string): AuthFlow {
  if (route === 'signUp') {
    return 'signUp';
  }
  if (route === 'confirmSignUp') {
    return 'confirmSignUp';
  }
  if (route === 'forgotPassword') {
    return 'forgotPassword';
  }
  if (route === 'confirmResetPassword') {
    return 'confirmResetPassword';
  }
  return 'signIn';
}
